/* @flow */
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import enTranslation from './translations/en';
import itTranslation from './translations/it';
import moment from 'moment';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react!!,
      format: (value, format, lng) => {
        moment.locale(lng);
        if (format === 'date') return moment(value).format('LL');
        if (format === 'datetime') return moment(value).format('LLLL');
        return value;
      },
    },
    resources: {
      en: {
        translations: enTranslation,
      },
      it: {
        translations: itTranslation,
      },
    },
  });

export default i18n;
